export const FormsMixin = {
    methods: {
        getQuestionByTag(tag) {
            let filteredQuestions = this.questions.filter((question) => {
                return question.tag === tag;
            });

            return filteredQuestions.length === 1 ? filteredQuestions[0] : {};
        },
        getAnswerTitle(tag) {
            return this.formData && this.formData[tag] && this.formData[tag].title;
        },
        getAnswerTag(tag) {
            return this.formData && this.formData[tag] && this.formData[tag].tag;
        },
        isValid() {
            return this.formValidation && this.formValidation.runAllValidations();
        },
        formatAnswers() {
            let data = {
                'answers': [],
            };
            for (let questionKey in this.formData) {
                if( questionKey[0] === 'Q'){
                    data['answers'].push({
                        id: this.formData[questionKey]['id'],
                        tag: questionKey
                    });
                }
                else {
                    data[questionKey] = this.formData[questionKey];
                }
            }

            return data;
        },
        deleteIf(questionTag, answerValue, questions) {

        }
    }
}
